const NotFound = () => {
    return (
        <div>
            <p>Opssss...</p>
        </div>
    );
}

export default NotFound;